import { render, staticRenderFns } from "./TicketInfo.vue?vue&type=template&id=230ad975&scoped=true&"
import script from "./TicketInfo.vue?vue&type=script&lang=ts&"
export * from "./TicketInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TicketInfo.vue?vue&type=style&index=0&id=230ad975&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ad975",
  null
  
)

export default component.exports